import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { roomReducer } from "./room/roomReducer";
import { authReducer, AuthState, initialState } from "./auth/authReducer";
import { rootSaga } from "./rootSaga";
import { lobbyReducer } from "./lobby/lobbyReducer";
import { packageReducer } from "./packages/packagesReducer";
import { loadAuthFromStorage } from "../utils/helpers/authStorage";
import { bonusReducer } from "./bonus/bonusReducer";
import { i18nReducer } from "./i18n/i18nReducer";
import { notificationsReducer } from "./userNotifications/notificationsReducer";
import { inviteReducer } from "./invites/inviteReducer";
import { rankingsReducer } from "./rankings/rankingsReducer";
import { tournamentsReducer } from "./tournaments/tournamentsReducer";
import { miniGamesReducer } from "./miniGames/miniGamesReducer";
import invitesSlice from "./invites/inviteSlice";
import { miniGamesRewardsReducer } from "./jackpot/miniGamesRewardsReducer";
import { iapReducer } from "./iap/iapReducer";
import { adRewardReducer } from "./adReward/adRewardReducer";
const saga = createSagaMiddleware();

const preloadedAuth: AuthState = {
  ...initialState,
  ...loadAuthFromStorage(),
};
const preloadedState = {
  auth: preloadedAuth,
};

export const store = configureStore({
  reducer: {
    room: roomReducer,
    auth: authReducer,
    lobby: lobbyReducer,
    package: packageReducer,
    bonus: bonusReducer,
    i18n: i18nReducer,
    notifications: notificationsReducer,
    invites: inviteReducer,
    activePlayers: invitesSlice,
    rankings: rankingsReducer,
    tournaments: tournamentsReducer,
    miniGames: miniGamesReducer,
    miniGamesRewards: miniGamesRewardsReducer,
    iap: iapReducer,
    adReward: adRewardReducer,
  },
  middleware: (getDefault) => getDefault({ thunk: false }).concat(saga),
  devTools: process.env.NODE_ENV !== "production",
  preloadedState,
});

saga.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;
